import { Group, Stack, Text } from '@mantine/core';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import type { GpSurfacesMapSamplerCoverageOrganization } from '../../../lib/types/gp-surfaces-map';
import {
  INCOMPLETE_SAMPLER_COVERAGE_COLOR,
  samplerOrganizationColor,
  SamplerOrganizationColorMap,
} from '../../../lib/utils/sampler-coverage-map';

type GpSurfacesMapSamplerCoverageLegendProps = {
  colorMap: SamplerOrganizationColorMap;
  samplerOrganizations: GpSurfacesMapSamplerCoverageOrganization[];
};

export const GpSurfacesMapSamplerCoverageLegend: FC<
  GpSurfacesMapSamplerCoverageLegendProps
> = ({ colorMap, samplerOrganizations }) => {
  const { t } = useTranslation();

  return (
    <Stack gap="xs">
      <Text fw={600} size="xs">
        {t('surfacesMap.samplerCoverage.legendTitle')}
      </Text>
      {samplerOrganizations.map((organization) => (
        <Group gap="xs" key={organization.id} wrap="nowrap">
          <span
            style={{
              background: samplerOrganizationColor(organization.id, colorMap),
              borderRadius: 2,
              flexShrink: 0,
              height: 12,
              width: 12,
            }}
          />
          <Text lineClamp={2} size="xs">
            {organization.name}
          </Text>
        </Group>
      ))}
      <Group gap="xs" wrap="nowrap">
        <span
          style={{
            background: INCOMPLETE_SAMPLER_COVERAGE_COLOR,
            border: '1px solid #ced4da',
            borderRadius: 2,
            flexShrink: 0,
            height: 12,
            width: 12,
          }}
        />
        <Text size="xs">{t('surfacesMap.samplerCoverage.incomplete')}</Text>
      </Group>
      <Text c="dimmed" size="xs">
        {t('surfacesMap.samplerCoverage.stripeHint')}
      </Text>
    </Stack>
  );
};
